module.exports = __webpack_public_path__ + "img/momo-desktop.c9f394c0.png";